"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getVaultDepositors = exports.getVaultInfoFromVault = exports.getAllVaultsWithDescription = exports.getAddressRoleOnVault = exports.getVaultDescriptionHash = exports.getAllVaultsAddressesByChain = exports.getVaultInfoWithCommittee = exports.getAllVaultsInfoWithCommittee = void 0;
const axios_1 = __importDefault(require("axios"));
const ethers_1 = require("ethers");
const utils_js_1 = require("ethers/lib/utils.js");
const config_1 = require("../config");
const gnosis_utils_1 = require("./gnosis.utils");
const ipfs_utils_1 = require("./ipfs.utils");
const vaultEditor_utils_1 = require("./vaultEditor.utils");
const getAllVaultsInfoWithCommittee = async () => {
    var _a, _b;
    try {
        const GET_ALL_VAULTS = `
      query getVaults {
        vaults {
          id
          pid
          registered
          version
          committee
          stakingToken
          claimsManager
          master {
            address
          }
          rewardControllers {
            id
            token: rewardToken
            tokenSymbol: rewardTokenSymbol
            tokenDecimals: rewardTokenDecimals
          }
        }
      }
    `;
        const subgraphsRequests = Object.values(config_1.ChainsConfig).map(async (chain) => {
            return {
                chainId: chain.chain.id,
                request: await axios_1.default.post(chain.subgraph, JSON.stringify({
                    query: GET_ALL_VAULTS,
                }), {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }),
            };
        });
        const subgraphsResponses = await Promise.allSettled(subgraphsRequests);
        const fulfilledResponses = subgraphsResponses.filter((response) => response.status === "fulfilled");
        const subgraphsData = fulfilledResponses.map((res) => res.value);
        const vaults = [];
        for (let i = 0; i < subgraphsData.length; i++) {
            const chainId = subgraphsData[i].chainId;
            if (!subgraphsData[i].request.data || !((_b = (_a = subgraphsData[i].request.data) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.vaults))
                continue;
            for (const vault of subgraphsData[i].request.data.data.vaults) {
                vaults.push({
                    chainId,
                    address: vault.id,
                    master: vault.master.address,
                    pid: vault.pid,
                    version: vault.version,
                    committee: vault.committee,
                    registered: vault.registered,
                    stakingToken: vault.stakingToken,
                    claimsManager: vault.claimsManager,
                    rewardControllers: vault.rewardControllers,
                });
            }
        }
        return vaults;
    }
    catch (error) {
        return [];
    }
};
exports.getAllVaultsInfoWithCommittee = getAllVaultsInfoWithCommittee;
const getVaultInfoWithCommittee = async (vaultId, chainId) => {
    var _a, _b, _c;
    try {
        if (!vaultId || !chainId)
            return undefined;
        const GET_VAULT_BY_ID = `
      query getVaults($vaultId: String) {
        vaults(where: {id: $vaultId}) {
          id
          pid
          registered
          version
          committee
          stakingToken
          claimsManager
          governanceHatRewardSplit
          descriptionHash
          master {
            address
          }
        }
      }
    `;
        const subgraphResponse = axios_1.default.post(config_1.ChainsConfig[chainId].subgraph, JSON.stringify({
            query: GET_VAULT_BY_ID,
            variables: { vaultId },
        }), {
            headers: {
                "Content-Type": "application/json",
            },
        });
        const subgraphData = (await subgraphResponse).data;
        const vault = (_b = (_a = subgraphData === null || subgraphData === void 0 ? void 0 : subgraphData.data) === null || _a === void 0 ? void 0 : _a.vaults) === null || _b === void 0 ? void 0 : _b[0];
        if (!vault)
            return undefined;
        const loadVaultDescription = async (vault) => {
            if ((0, ipfs_utils_1.isValidIpfsHash)(vault.descriptionHash)) {
                try {
                    const dataResponse = await fetch(`https://ipfs2.hats.finance/ipfs/${vault.descriptionHash}`);
                    if (dataResponse.status === 200) {
                        const object = await dataResponse.json();
                        return (0, vaultEditor_utils_1.fixObject)(object);
                    }
                    return undefined;
                }
                catch (error) {
                    // console.error(error);
                    return undefined;
                }
            }
            return undefined;
        };
        const description = await loadVaultDescription(vault);
        return {
            chainId,
            address: vault.id,
            master: vault.master.address,
            pid: vault.pid,
            version: vault.version,
            committee: vault.committee,
            registered: vault.registered,
            stakingToken: vault.stakingToken,
            claimsManager: vault.claimsManager,
            hatsGovFee: Number(vault.governanceHatRewardSplit) === 0 && vault.version === "v3" && description
                ? ((_c = description.parameters.fixedHatsGovPercetange) !== null && _c !== void 0 ? _c : 0) * 100
                : vault.governanceHatRewardSplit,
        };
    }
    catch (error) {
        return undefined;
    }
};
exports.getVaultInfoWithCommittee = getVaultInfoWithCommittee;
const getAllVaultsAddressesByChain = async (chainId) => {
    var _a;
    if (!chainId)
        return [];
    try {
        const GET_VAULTS = `
    query getVaults {
      vaults(where: {version_not: "v1"}) {
        id
        descriptionHash
        registered
        claimsManager
        version
      }
    }
  `;
        const subgraphResponse = axios_1.default.post(config_1.ChainsConfig[chainId].subgraph, JSON.stringify({
            query: GET_VAULTS,
        }), {
            headers: {
                "Content-Type": "application/json",
            },
        });
        const subgraphData = (await subgraphResponse).data;
        const vaults = (_a = subgraphData === null || subgraphData === void 0 ? void 0 : subgraphData.data) === null || _a === void 0 ? void 0 : _a.vaults;
        if (!vaults)
            return [];
        return vaults;
    }
    catch (error) {
        return [];
    }
};
exports.getAllVaultsAddressesByChain = getAllVaultsAddressesByChain;
const getVaultDescriptionHash = async (vaultId, chainId) => {
    var _a, _b;
    try {
        if (!vaultId || !chainId)
            return undefined;
        const GET_VAULT_BY_ID = `
      query getVaults($vaultId: String) {
        vaults(where: {id: $vaultId}) {
          id
          descriptionHash
        }
      }
    `;
        const subgraphResponse = axios_1.default.post(config_1.ChainsConfig[chainId].subgraph, JSON.stringify({
            query: GET_VAULT_BY_ID,
            variables: { vaultId },
        }), {
            headers: {
                "Content-Type": "application/json",
            },
        });
        const subgraphData = (await subgraphResponse).data;
        const vault = (_b = (_a = subgraphData === null || subgraphData === void 0 ? void 0 : subgraphData.data) === null || _a === void 0 ? void 0 : _a.vaults) === null || _b === void 0 ? void 0 : _b[0];
        if (!vault)
            return undefined;
        return vault.descriptionHash;
    }
    catch (error) {
        return undefined;
    }
};
exports.getVaultDescriptionHash = getVaultDescriptionHash;
const getAddressRoleOnVault = async (address, vaultChainId, vaultCommittee) => {
    var _a;
    if (!address || !vaultCommittee || !vaultChainId)
        return "none";
    const govMultisig = config_1.ChainsConfig[Number(vaultChainId)].govMultisig;
    const growthMultisig = config_1.ChainsConfig[Number(vaultChainId)].growthMultisig;
    const committeeMultisig = vaultCommittee;
    const isCommitteeMultisig = committeeMultisig === address;
    const isCommitteeMultisigMember = await (0, gnosis_utils_1.isAddressAMultisigMember)(committeeMultisig, address, vaultChainId);
    const isGovMember = await (0, gnosis_utils_1.isAddressAMultisigMember)(govMultisig, address, vaultChainId);
    const isGrowthMember = await (0, gnosis_utils_1.isAddressAMultisigMember)(growthMultisig, address, vaultChainId);
    const whitelistedReviewers = (_a = config_1.ChainsConfig[Number(vaultChainId)].whitelistedReviewers) !== null && _a !== void 0 ? _a : [];
    const whitelistedReviewersLowerCase = whitelistedReviewers.map((reviewer) => reviewer.toLowerCase());
    const isWhiteListedEditor = whitelistedReviewersLowerCase.includes(address.toLowerCase());
    if (isCommitteeMultisigMember)
        return "committee";
    if (isCommitteeMultisig)
        return "committee-multisig";
    if (isGovMember)
        return "gov";
    if (isGrowthMember)
        return "growth";
    if (isWhiteListedEditor)
        return "reviewer";
    return "none";
};
exports.getAddressRoleOnVault = getAddressRoleOnVault;
const getAllVaultsWithDescription = async (onlyMainnet = true) => {
    try {
        const GET_ALL_VAULTS = `
      query getVaults {
        vaults {
          id
          pid
          registered
          stakingToken
          stakingTokenDecimals
          descriptionHash
          honeyPotBalance
        }
      }
    `;
        const subgraphsRequests = Object.values(config_1.ChainsConfig).map(async (chain) => {
            return {
                chainId: chain.chain.id,
                request: await axios_1.default.post(chain.subgraph, JSON.stringify({
                    query: GET_ALL_VAULTS,
                }), {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }),
            };
        });
        const subgraphsResponses = await Promise.allSettled(subgraphsRequests);
        const fulfilledResponses = subgraphsResponses.filter((response) => response.status === "fulfilled");
        const subgraphsData = fulfilledResponses.map((res) => res.value);
        const vaults = [];
        for (let i = 0; i < subgraphsData.length; i++) {
            const chainId = subgraphsData[i].chainId;
            if (!subgraphsData[i].request.data || !subgraphsData[i].request.data.data.vaults)
                continue;
            for (const vault of subgraphsData[i].request.data.data.vaults) {
                vaults.push(Object.assign({ chainId }, vault));
            }
        }
        const loadVaultDescription = async (vault) => {
            if ((0, ipfs_utils_1.isValidIpfsHash)(vault.descriptionHash)) {
                try {
                    const dataResponse = await fetch(`https://ipfs2.hats.finance/ipfs/${vault.descriptionHash}`);
                    if (dataResponse.status === 200) {
                        const object = await dataResponse.json();
                        return (0, vaultEditor_utils_1.fixObject)(object);
                    }
                    return undefined;
                }
                catch (error) {
                    // console.error(error);
                    return undefined;
                }
            }
            return undefined;
        };
        // Load descriptions
        const getVaultsData = async (vaultsToFetch) => Promise.all(vaultsToFetch.map(async (vault) => {
            const description = (await loadVaultDescription(vault));
            return Object.assign(Object.assign({}, vault), { description });
        }));
        const vaultsWithDescription = await getVaultsData(vaults);
        return vaultsWithDescription;
    }
    catch (error) {
        return [];
    }
};
exports.getAllVaultsWithDescription = getAllVaultsWithDescription;
const getVaultInfoFromVault = (vault) => {
    return {
        version: vault.version,
        address: vault.id,
        chainId: vault.chainId,
        master: vault.master.address,
        pid: vault.pid,
        stakingToken: vault.stakingToken,
        claimsManager: vault.claimsManager,
        hatsGovFee: vault.governanceHatRewardSplit,
    };
};
exports.getVaultInfoFromVault = getVaultInfoFromVault;
/*
 * Get the depositors of a vault
 * @param vault - The vault to get the depositors from
 *
 * @returns An array of depositors with their shares and ownership (percentage of the vault shares they own)
 *
 */
const getVaultDepositors = (vault) => {
    if (!vault || !vault.stakers)
        return [];
    return vault.stakers.map((staker) => ({
        address: staker.address,
        shares: Number((0, utils_js_1.formatUnits)(ethers_1.BigNumber.from(staker.shares), +vault.stakingTokenDecimals)),
        ownership: +((+(0, utils_js_1.formatUnits)(ethers_1.BigNumber.from(staker.shares), +vault.stakingTokenDecimals) /
            +(0, utils_js_1.formatUnits)(ethers_1.BigNumber.from(vault.totalUsersShares), +vault.stakingTokenDecimals)) *
            100).toFixed(2),
    }));
};
exports.getVaultDepositors = getVaultDepositors;
